import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-white text-body-1 font-weight-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "text-white text-body-1 font-weight-bold"
}
const _hoisted_3 = {
  key: 2,
  class: "text-white text-body-1 font-weight-bold"
}
const _hoisted_4 = {
  key: 1,
  class: "text-white"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_LoginError = _resolveComponent("LoginError")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "center",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "10",
        lg: "6",
        class: "pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            color: "background",
            class: "px-4 py-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.goToEmail(); _ctx.clearError(); _ctx.password = ''}),
                        icon: "",
                        color: "secondary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-arrow-left")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-center" }, {
                    default: _withCtx(() => [
                      (_ctx.activated)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Enter your password"))
                        : (!_ctx.activated && !_ctx.isNew)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Enter your registration code"))
                          : _createCommentVNode("", true),
                      (!_ctx.activated && _ctx.isNew)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Enter your new password"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        width: "36",
                        height: "36",
                        color: "transparent"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LoginError, { error: _ctx.error }, null, 8, ["error"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-0"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_v_form, {
                            key: 0,
                            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.checkPassword(_ctx.password)), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.activated)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    autofocus: "",
                                    class: "custom-field",
                                    placeholder: 'Password',
                                    "persistent-placeholder": "",
                                    variant: "outlined",
                                    "bg-color": "#ffffff",
                                    "append-icon": _ctx.value ? 'mdi-eye' : 'mdi-eye-off',
                                    "onClick:append": _cache[1] || (_cache[1] = () => (_ctx.value = !_ctx.value)),
                                    type: _ctx.value ? 'password' : 'text',
                                    modelValue: _ctx.password,
                                    "onUpdate:modelValue": [
                                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                                      _ctx.clearError
                                    ],
                                    rules: [v => !!v && !!v.length],
                                    autocomplete: "current-password"
                                  }, null, 8, ["append-icon", "type", "modelValue", "rules", "onUpdate:modelValue"]))
                                : (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 1,
                                    class: "custom-field",
                                    placeholder: "Registration code",
                                    "persistent-placeholder": "",
                                    variant: "outlined",
                                    "bg-color": "#ffffff",
                                    modelValue: _ctx.code,
                                    "onUpdate:modelValue": [
                                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code) = $event)),
                                      _ctx.clearError
                                    ],
                                    autocomplete: "new-password"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_v_form, {
                            key: 1,
                            modelValue: _ctx.passwordValid,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.passwordValid) = $event)),
                            ref: "passwordForm",
                            onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.checkPassword(_ctx.password)), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                autofocus: "",
                                class: "custom-field",
                                placeholder: "New password",
                                "persistent-placeholder": "",
                                variant: "outlined",
                                "bg-color": "#ffffff",
                                "append-icon": _ctx.value['new'] ? 'mdi-eye' : 'mdi-eye-off',
                                "onClick:append": _cache[5] || (_cache[5] = () => (_ctx.value['new'] = !_ctx.value['new'])),
                                type: _ctx.value['new'] ? 'password' : 'text',
                                "onUpdate:modelValue": [
                                  _cache[6] || (_cache[6] = ($event: any) => (_ctx.$refs.repeatPasswordForm.validate())),
                                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.password) = $event))
                                ],
                                modelValue: _ctx.password,
                                rules: [
                      (v) => (v && v.length >= 6) || 'Password must be at least 6 characters long.',
                      (v) => (v && v.toUpperCase() !== v) || 'Password must contain a lowercase character.',
                      (v) => (v && v.toLowerCase() !== v) || 'Password must contain an uppercase character.',
                      (v) => (v && /\d/.test(v)) || 'Password must contain a number.',
                      (v) => (v && _ctx.symbols.test(v)) || 'Password must contain a special character.',
                  ],
                                autocomplete: "new-password"
                              }, null, 8, ["append-icon", "type", "modelValue", "rules"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.isNew)
                        ? (_openBlock(), _createBlock(_component_v_form, {
                            key: 2,
                            modelValue: _ctx.repeatValid,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.repeatValid) = $event)),
                            ref: "repeatPasswordForm",
                            onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.checkPassword(_ctx.password)), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                class: "custom-field",
                                placeholder: "Repeat new password",
                                "persistent-placeholder": "",
                                variant: "outlined",
                                "bg-color": "#ffffff",
                                "append-icon": _ctx.value['repeat'] ? 'mdi-eye' : 'mdi-eye-off',
                                "onClick:append": _cache[10] || (_cache[10] = () => (_ctx.value['repeat'] = !_ctx.value['repeat'])),
                                type: _ctx.value['repeat'] ? 'password' : 'text',
                                modelValue: _ctx.repeatedPassword,
                                "onUpdate:modelValue": [
                                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.repeatedPassword) = $event)),
                                  _cache[12] || (_cache[12] = ($event: any) => (_ctx.$refs.repeatPasswordForm.validate()))
                                ],
                                rules: [
                      (v) => !_ctx.passwordValid || v === _ctx.password || 'Passwords do not match.'
                  ],
                                autocomplete: "new-password"
                              }, null, 8, ["append-icon", "type", "modelValue", "rules"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center pt-0"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.activated)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToForgotPassword())),
                            style: {"color":"#f2243f"}
                          }, "Forgot your password?"))
                        : (!_ctx.isNew)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createTextVNode("Don't have your registration code? "),
                              _hoisted_5,
                              _createTextVNode(),
                              _createElementVNode("a", {
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goToResendRegistration())),
                                style: {"color":"#f2243f"}
                              }, "Resend it.")
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ActionButton, {
                        width: "95",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkPassword(_ctx.password))),
                        text: "Confirm",
                        color: "secondary",
                        loading: _ctx.loading,
                        disabled: _ctx.confirmedDisabled || _ctx.loading
                      }, null, 8, ["loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}